import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectRequestFormSchema } from '../../../selectors/requestFormSchema';
import { handleNextStep, handlePrevStep } from '../../../actions/legalCheck';
import { TThunkDispatch } from '../../../types/redux';
import { useDefaultInputMode } from '../../AddressCadastreFieldContainer';
import { getDefaultInputMode } from './getDefaultInputMode';
import { getPaymentUrl } from '../../../actions/paymentStatus';
import { useRequestFormTracking } from './useRequestFormTracking';
import { TRequestFormCallbackProps } from '../../../types/requestForm';

export const useRequestForm = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const { trackNext, trackPrev, trackSubmit } = useRequestFormTracking();
  const { stepsSchema, skipSteps, firstStepCode, transformFields, initialFormValue, initialStepCode } =
    useSelector(selectRequestFormSchema);
  const [defaultInputMode, setDefaultInputMode] = useDefaultInputMode();

  // устанавливаем значение активного таба (режима ввода) в инпуте AddressCadastre при инициализации
  useEffect(() => {
    setDefaultInputMode(getDefaultInputMode(initialFormValue));
  }, [setDefaultInputMode, initialFormValue]);

  const handleSubmit = useCallback(() => {
    trackSubmit();

    return dispatch(getPaymentUrl());
  }, [dispatch, trackSubmit]);

  const handleNext = useCallback(
    (props: TRequestFormCallbackProps) => {
      trackNext(props);

      // обновляем значение активного таба (режима ввода) в инпуте AddressCadastre
      setDefaultInputMode(getDefaultInputMode(props.formValue));

      return dispatch(handleNextStep(props));
    },
    [dispatch, trackNext, setDefaultInputMode],
  );

  const handlePrev = useCallback(
    (props: TRequestFormCallbackProps) => {
      trackPrev();

      dispatch(handlePrevStep(props));

      // Сбрасываем несохраненные значения
      return props.prevFormValue;
    },
    [dispatch, trackPrev],
  );

  return {
    stepsSchema,
    firstStepCode,
    skipSteps,
    transformFields,
    defaultInputMode,
    initialStepCode,
    initialFormValue,
    handleSubmit,
    handleNext,
    handlePrev,
  };
};
